<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {removeWatermark, setWaterMark} from '@/utils/water_mark'
import {mapGetters} from 'vuex'

let text = '';
if (process.env.NODE_ENV === 'development') {
  text = '本地开发环境';
} else if (process.env.NODE_ENV === 'test') {
  text = '游戏接入测试环境';
} else if (process.env.NODE_ENV === 'production') {
  text = '生产环境';
} else if (process.env.NODE_ENV === 'active') {
  text = '体验服环境';
} else if (process.env.NODE_ENV === 'pr') {
  text = '预发布环境';
} else if (process.env.NODE_ENV === 'mcdev') {
  text = '开发测试环境';
}

export default {
  name: 'App',
  computed: {
    ...mapGetters(['name', "androidGame", "iosGame"]),
  },
  watch: {
    'androidGame.gName'(val) { // 实时监听数据变化
      setWaterMark(text, this.name, this.androidGame.gName?this.androidGame.gName:'', this.iosGame.gName?this.iosGame.gName:'');
    },
    'iosGame.gName'(val) { // 实时监听数据变化
      setWaterMark(text, this.name, this.androidGame.gName?this.androidGame.gName:'', this.iosGame.gName?this.iosGame.gName:'');
    },
    name() {
      setWaterMark(text, this.name, this.androidGame.gName?this.androidGame.gName:'', this.iosGame.gName?this.iosGame.gName:'');
    }
  },
  mounted() {
    setWaterMark(text, this.name, this.androidGame.gName?this.androidGame.gName:'', this.iosGame.gName?this.iosGame.gName:'');
  },
  destroyed() {
    removeWatermark();
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue